"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _sortable = require("@dnd-kit/sortable");
var _utilities = require("@dnd-kit/utilities");
var _box = require("@oneloop/box");
var _icons = require("@oneloop/icons");
var _useSize3 = _interopRequireDefault(require("./hooks/useSize"));
var _useAspectRatio3 = _interopRequireDefault(require("./hooks/useAspectRatio"));
var _getTooltipErrorText = require("./utils/getTooltipErrorText");
var _manageItem = require("./utils/manageItem");
require("../styles/ImageItem.css");
require("../styles/ImageItemBlanket.css");
require("../styles/ImageItemCover.css");
require("../styles/ImageItemSmallElements.css");
require("../styles/ImageItemTooltip.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var ImageItem = function ImageItem(_ref) {
  var item = _ref.item,
    handleClick = _ref.handleClick,
    handleUpdateItem = _ref.handleUpdateItem,
    onEdit = _ref.onEdit,
    status = _ref.status,
    config = _ref.config,
    texts = _ref.texts,
    sizeFetcher = _ref.sizeFetcher;
  var _useSortable = (0, _sortable.useSortable)({
      id: item.id
    }),
    attributes = _useSortable.attributes,
    listeners = _useSortable.listeners,
    setNodeRef = _useSortable.setNodeRef,
    transform = _useSortable.transform,
    transition = _useSortable.transition;
  var _useSize = (0, _useSize3["default"])(item.src, sizeFetcher),
    _useSize2 = _slicedToArray(_useSize, 3),
    size = _useSize2[0],
    isLoadingSize = _useSize2[1],
    isErrorSize = _useSize2[2];
  var _useAspectRatio = (0, _useAspectRatio3["default"])(item.src),
    _useAspectRatio2 = _slicedToArray(_useAspectRatio, 5),
    height = _useAspectRatio2[0],
    width = _useAspectRatio2[1],
    aspectRatio = _useAspectRatio2[2],
    isLoadingAspectRatio = _useAspectRatio2[3],
    isErrorAspectRatio = _useAspectRatio2[4];
  var wrapperRef = (0, _react.useRef)(null);
  var _useState = (0, _react.useState)({
      left: 0,
      top: 0
    }),
    _useState2 = _slicedToArray(_useState, 2),
    tooltipPosition = _useState2[0],
    setTooltipPosition = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isTooltipShowable = _useState4[0],
    setIsTooltipShowable = _useState4[1];
  var isDraggingActive = status.isDraggingActive,
    isMaxSelectableReached = status.isMaxSelectableReached,
    itemsAreReady = status.itemsAreReady;
  var maxSizeInMB = config.maxSizeInMB,
    minAspectRatio = config.minAspectRatio,
    maxAspectRatio = config.maxAspectRatio;
  var isLoading = item.loading;
  var isError = item.sizeError || item.aspectRatioError || item.fetchError;
  var isFizableError = !item.fetchError && onEdit;
  var tooltipErrorText = (0, _getTooltipErrorText.getTooltipErrorText)(item, texts, onEdit);
  var backgroundImage = item.loading || item.fetchError ? '' : "url(".concat(item.src, ")");
  var unclickable = !(0, _manageItem.isItemClickable)(item, isMaxSelectableReached, itemsAreReady);
  var disabled = (0, _manageItem.isDisabledCheckbox)(item, isMaxSelectableReached);
  (0, _react.useEffect)(function () {
    var handleHideTooltip = function handleHideTooltip() {
      setIsTooltipShowable(false);
    };
    document.addEventListener('wheel', handleHideTooltip);
    document.addEventListener('scroll', handleHideTooltip);
    return function () {
      document.removeEventListener('wheel', handleHideTooltip);
      document.removeEventListener('scroll', handleHideTooltip);
    };
  }, []);
  (0, _react.useEffect)(function () {
    var id = item.id;
    var sizeError = !isNaN(maxSizeInMB) && size > maxSizeInMB;
    var aspectRatioError = !isNaN(maxAspectRatio) && aspectRatio > maxAspectRatio || !isNaN(minAspectRatio) && aspectRatio < minAspectRatio;
    var fetchError = isErrorSize || isErrorAspectRatio;
    var loading = isLoadingSize || isLoadingAspectRatio;
    handleUpdateItem({
      id: id,
      size: size,
      sizeError: sizeError,
      height: height,
      width: width,
      aspectRatio: aspectRatio,
      aspectRatioError: aspectRatioError,
      fetchError: fetchError,
      loading: loading
    });
  }, [size, isLoadingSize, isErrorSize, aspectRatio, isLoadingAspectRatio, isErrorAspectRatio]);
  var calculateTooltipPosition = function calculateTooltipPosition() {
    var parent = document.querySelector('.gridImagePickerContainer');
    var parentRects = parent.getBoundingClientRect();
    var imageRects = wrapperRef.current.getBoundingClientRect();
    var left = imageRects.left - parentRects.left + imageRects.width / 2;
    var top = imageRects.top - parentRects.top;
    setTooltipPosition({
      left: left,
      top: top
    });
  };
  var handleMouseMove = function handleMouseMove() {
    var shouldShowTooltip = Boolean(tooltipErrorText);
    calculateTooltipPosition();
    setIsTooltipShowable(shouldShowTooltip);
  };
  var handleEdit = function handleEdit(e) {
    e.stopPropagation();
    onEdit(item);
  };
  return /*#__PURE__*/_react["default"].createElement(_box.Box, {
    className: "imageItemOuterWrapper"
  }, /*#__PURE__*/_react["default"].createElement(_box.Box, _extends({
    ref: function ref(node) {
      setNodeRef(node);
      wrapperRef.current = node;
    },
    as: "button",
    className: "imageItemWrapper",
    onClick: function onClick() {
      return isFizableError && isError ? onEdit(item) : handleClick(item);
    },
    onMouseMove: handleMouseMove,
    "data-dragging": isDraggingActive,
    __css: {
      backgroundImage: backgroundImage
    },
    style: {
      transform: _utilities.CSS.Transform.toString(transform),
      transition: transition
    }
  }, attributes, listeners), /*#__PURE__*/_react["default"].createElement(_box.Box, {
    className: "imageItemBlanket",
    "data-light": unclickable,
    "data-dark": item.checked,
    "data-grey": isError
  }), /*#__PURE__*/_react["default"].createElement(_box.Box, {
    className: "imageItemCount",
    "data-visible": item.checked
  }, item.position), /*#__PURE__*/_react["default"].createElement(_box.Box, {
    className: "imageItemCover",
    "data-visible": item.position === 1
  }, /*#__PURE__*/_react["default"].createElement(_box.Box, {
    className: "imageItemCoverText"
  }, " ", texts.cover, " ")), /*#__PURE__*/_react["default"].createElement(_box.Box, {
    className: "imageItemCheckbox",
    "data-active": item.checked,
    "data-disabled": disabled,
    "data-visible": !unclickable
  }, /*#__PURE__*/_react["default"].createElement(_icons.Check, {
    className: "imageItemIconCheck",
    color: "white"
  })), /*#__PURE__*/_react["default"].createElement(_box.Box, {
    className: "imageItemError",
    "data-visible": isError && !isLoading
  }, /*#__PURE__*/_react["default"].createElement(_icons.Icon, {
    icon: "icon-error",
    className: "imageItemIconError"
  })), /*#__PURE__*/_react["default"].createElement(_box.Box, {
    className: "imageItemEdit",
    "data-visible": isFizableError && !isLoading,
    onClick: function onClick(e) {
      return handleEdit(e);
    }
  }, /*#__PURE__*/_react["default"].createElement(_icons.Icon, {
    icon: "icon-editar",
    className: "imageItemIconEdit"
  }))), /*#__PURE__*/_react["default"].createElement(_box.Box, {
    className: "imageItemTooltip",
    "data-showable": isTooltipShowable,
    __css: {
      left: tooltipPosition.left,
      top: tooltipPosition.top
    }
  }, tooltipErrorText));
};
var _default = exports["default"] = ImageItem;